import { render, staticRenderFns } from "./commission.vue?vue&type=template&id=2c3e0fc8&scoped=true&lang=pug&"
import script from "./commission.vue?vue&type=script&lang=js&"
export * from "./commission.vue?vue&type=script&lang=js&"
import style0 from "./commission.vue?vue&type=style&index=0&id=2c3e0fc8&prod&lang=sass&scoped=true&"
import style1 from "./commission.vue?vue&type=style&index=1&id=2c3e0fc8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3e0fc8",
  null
  
)

export default component.exports